module.exports = __webpack_public_path__ + "img/tut_img_2_onlyappleshalf_wo_ground.ed8bcac0.svg";